import { defineMessages } from 'react-intl';

export default defineMessages({
  button: {
    id: 'pages.Welcome.button',
    defaultMessage: 'REGISTER',
  },
  description: {
    id: 'pages.Welcome.description',
    defaultMessage: 'To get free car assistance, please select a way to identify yourself',
  },
  title: {
    id: 'pages.Welcome.title',
    defaultMessage: 'Home',
  },
});
